"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmationDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _hooks = require("../../hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ConfirmationDialog = ({
  onCancel,
  onConfirm
}) => {
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    open,
    onClose
  } = (0, _presentationHooks.useDisclose)({
    defaultOpen: true
  });
  const {
    open: buttonsEnabled,
    onClose: disableButtons
  } = (0, _presentationHooks.useDisclose)({
    defaultOpen: true
  });
  const confirm = (0, _react.useCallback)(() => {
    disableButtons();
    onConfirm();
  }, [disableButtons, onConfirm]);
  const cancel = (0, _react.useCallback)(() => {
    disableButtons();
    onClose();
    onCancel();
  }, [disableButtons, onCancel, onClose]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledDialog, {
    fullWidth: true,
    hideCloseButton: true,
    open: open,
    maxWidth: "440px",
    onClose: cancel,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      textAlign: "center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledInfoCircle, {
        fontSize: "large"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ConfirmationTypography, {
        variant: "h4",
        children: translations.DialogTitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.QuestionTypography, {
        children: translations.DialogQuestion
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Buttons, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
          fullWidth: true,
          variant: "contained",
          color: "primary",
          disabled: !buttonsEnabled,
          onClick: confirm,
          children: translations.ConfirmationLabel
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
          fullWidth: true,
          variant: "text",
          disabled: !buttonsEnabled,
          onClick: cancel,
          children: translations.CancelLabel
        })]
      })]
    })
  });
};
exports.ConfirmationDialog = ConfirmationDialog;
